(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dreamlover-wig-grip-guide"] && !Shopify.designMode) return;
  try {
    class DreamloverGuideDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-guide-dialog]');
      this.openButton = this.querySelector('[data-guide-open]');
      this.closeButton = this.querySelector('[data-guide-close]');

      this.openButton?.addEventListener('click', this.openDialog);
      this.closeButton?.addEventListener('click', this.closeDialog);
      this.dialog?.addEventListener('click', this.handleBackdropClick);
      this.dialog?.addEventListener('close', this.handleClosed);
    }

    disconnectedCallback() {
      this.openButton?.removeEventListener('click', this.openDialog);
      this.closeButton?.removeEventListener('click', this.closeDialog);
      this.dialog?.removeEventListener('click', this.handleBackdropClick);
      this.dialog?.removeEventListener('close', this.handleClosed);
    }

    openDialog = () => {
      if (!this.dialog) return;
      if (typeof this.dialog.showModal === 'function' && !this.dialog.open) this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      this.closeButton?.focus();
    };

    closeDialog = () => {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close();
      else {
        this.dialog.removeAttribute('open');
        this.handleClosed();
      }
    };

    handleBackdropClick = (event) => {
      if (event.target === this.dialog) this.closeDialog();
    };

    handleClosed = () => {
      document.documentElement.style.removeProperty('overflow');
      this.openButton?.focus();
    };
  }

  if (!customElements.get('dreamlover-guide-drawer')) {
    customElements.define('dreamlover-guide-drawer', DreamloverGuideDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
